import { makeAutoObservable } from "mobx"
import request from "../helpers/request";

class ApiKeyStore {

  keys = [];
  loading = false;

  constructor() {
    makeAutoObservable(this)
  }

  setKeys(keys) {
    this.keys = keys;
  }

  getKeys = () => {
    return new Promise(async (resolve, reject) => {
      try {
        this.loading = true;
        const resp = await request("apikeys/list", "GET");
        if (resp && resp.keys) {
          this.setKeys(resp.keys);
        }
        this.loading = false;
        resolve(this.keys);
      } catch (error) {
        this.loading = false;
        reject(error);
      }
    });
  }

  // Resolves with {key, id, name, prefix} — the raw key is shown to the user
  // exactly once and never stored client-side.
  createKey = (name) => {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await request("apikeys/create", "POST", { name });
        await this.getKeys();
        resolve(resp && resp.done ? resp : null);
      } catch (error) {
        reject(error);
      }
    });
  }

  revokeKey = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await request("apikeys/revoke", "POST", { id });
        await this.getKeys();
        resolve(resp);
      } catch (error) {
        reject(error);
      }
    });
  }
}

const apiKeyStore = new ApiKeyStore();
export default apiKeyStore;
